import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { TechnicalFeaturesGroups } from 'src/app/models';

@Component({
    selector: 'app-products-technical-features-groups-add',
    templateUrl: './products-technical-features-groups-add.component.html',
    styleUrls: ['./products-technical-features-groups-add.component.css'],
    standalone: false
})
export class ProductsTechnicalFeaturesGroupsAddComponent extends GenericCrudAddComponent<TechnicalFeaturesGroups> {

  constructor() {
    super();
    this.resource = this.api.resources.product.technicalFeatureGroups;
  }

  override initFormGroup(): FormGroup {
    const group = this.fb.group({
      name: [''],
    });
    return group;
  }

  override async mapFormEntity(): Promise<TechnicalFeaturesGroups> {
    var technicalFeatureGroup = this.form!.value as TechnicalFeaturesGroups;
    technicalFeatureGroup.companyId = this.api.auth.userValue!.lastCompanyId;
    return technicalFeatureGroup;
  }
}
